import { render, staticRenderFns } from "./register-login.vue?vue&type=template&id=b7b19d42&scoped=true&lang=pug"
import script from "./register-login.vue?vue&type=script&lang=ts"
export * from "./register-login.vue?vue&type=script&lang=ts"
import style0 from "./register-login.vue?vue&type=style&index=0&id=b7b19d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b19d42",
  null
  
)

export default component.exports